<div id="VerCotizador">
    <div id="quotes" class="quotes" *ngIf="templateView==1">
        <h2 class="mt-3 font-weight-bolder">
            <div class="row">
                <div class="col-10">
                    <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> 
                    <span>{{ "QUOTES.QUOTES" | translate }}</span>
                </div>
            </div>
        </h2>

        <div class="card card-custom gutter-b mt-10">
            <div class="card-body py-0 px-0">
                <div class="row mx-3">
                    <div class="col-md-12 mt-5">
                        <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                    </div>
                </div>
                <div class="form-group row mx-3 justify-content-md-left">
                    
                    <div class="col-md-12 my-5 ">
                        <form
                        [formGroup]="filterQuoteForm"
                        (ngSubmit)="submitFilterQuote()"
                        >
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INSURANCE.INSURED" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'INSURANCE.INSURED' | translate }}" formControlName="inputAsegurado" name="inputAsegurado">
                                    </div>
                                </div>
                                
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "QUOTES.QUOTEID" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'QUOTES.QUOTEID' | translate }}" formControlName="inputNroCotizacion" name="inputNroCotizacion">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group kt-form__group">
                                                <label class="sr-only">{{ "INPUT.DATESTART" | translate }}</label>
                                                <div class="input-group">
                                                    <input class="form-control" formControlName="inputFechaDesde" name="inputFechaDesde" placeholder="" ngbDatepicker #d1="ngbDatepicker" autocomplete="false" readonly>
                                                    <div class="input-group-append">
                                                    <button class="btn btn-primary" (click)="d1.toggle()" type="button">
                                                        <i class="fa fa-calendar"></i>
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group kt-form__group">
                                                <label class="sr-only">{{ "INPUT.DATEEND" | translate }}</label>
                                                <div class="input-group">
                                                    <input class="form-control" formControlName="inputFechaHasta" name="inputFechaHasta" placeholder="" ngbDatepicker #d2="ngbDatepicker" autocomplete="false" readonly>
                                                    <div class="input-group-append">
                                                    <button class="btn btn-primary" (click)="d2.toggle()" type="button">
                                                        <i class="fa fa-calendar"></i>
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

								<div class="col-md-2">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INPUT.STATUS" | translate }}</label>
                                        <select class="form-control" placeholder="" name="inputIdEstatus" formControlName="inputIdEstatus">
                                            <option value="">{{ "QUOTES.SELECT_STATUS" | translate }}</option>
                                            <option *ngFor="let item of estatus | async" value="{{item.IdEstatus}}">{{item.Estatus}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="false">
                                <div class="col-md-2" *ngIf="false">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INPUT.AGE" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'INPUT.AGE' | translate }}" formControlName="inputEdad" name="inputEdad">
                                    </div>
                                </div>

                                <div class="col-md-3" *ngIf="VerEvaluacionCotizacionVida && false">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INPUT.AGENT" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'INPUT.AGENT' | translate }}" formControlName="inputAgente" name="inputAgente">
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div class="row justify-content-end">
                                <div class="col-md-6 ">
                                    <div class="row">
										<div class="col-12">
											<a *ngIf="cotizadorLink" href="{{cotizadorLink}}" class="btn btn-secondary text-white font-weight-boldest" target="_blank">{{ "QUOTES.NEW" | translate }}</a>
										</div>
                                    </div>
                                </div>

                                <div class="col-md-6 ">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group mb-0 text-right">
                                                <button [disabled]="activeSubmitFilterQuote" type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" value="filter" >{{ "INPUT.FILTER" | translate }}</button>
                                                <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-custom gutter-b my-10">
            <div class="card-header d-none">
                <div class="card-title">
                    <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
                </div>
            </div>
            
            <div class="card-body py-0 px-0">
                <div class="table-responsive angular-bootstrap-table">
                    <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                        <thead style="background-color: rgb(130,124,120);color:white;">
                            <th class="text-light">{{ "QUOTES.QUOTEID" | translate }}</th>
                            <th class="text-light">{{ "INSURANCE.INSURED" | translate }}</th>
                            <th>{{ "INSURANCE.PRODUCT" | translate }}</th>
                            <th>{{ "INSURANCE.PRIMA" | translate }}</th>
                            <th>{{ "INPUT.DATE" | translate }}</th>
                            <th>{{ "INSURANCE.STATUS" | translate }}</th>
                            <th width="15%">{{ "INSURANCE.OPTIONS" | translate }}</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of quoteService.items$ | async; let i = index">
                                <td>{{ item.NroCotizacion }}</td>
                                <td>{{ item.ASegurado }}</td>
                                <td>{{ item.Producto }}</td>
                                <td>{{ item.Prima }}</td>
                                <td>{{ item.FechaCreacion | date: 'MM/dd/yyyy' }}</td>
                                <td>{{ item.Estatus }}</td>
                                <td>
                                    <a href="{{ item.Link }}" class="btn pr-1" data-toggle="tooltip" title='{{ "QUOTES.QUOTEVIEW" | translate }}' target="_blank"><i class="fas fa-edit"></i></a>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr *ngIf="!quoteService.items$" class="">
                                <td>
                                    <div>
                                        <strong>{{"GENERAL.EMPTY_QUERY" | translate}}</strong>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>